/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue";
import _imports_0 from '../assets/img/image11.jpg';
var _hoisted_1 = {
  "class": "menu"
};
var _hoisted_2 = {
  "class": "menu-content"
};
var _hoisted_3 = ["onMouseover"];
var _hoisted_4 = {
  key: 0,
  "class": "flex_column_div"
};
export default /*@__PURE__*/_defineComponent({
  __name: 'NavViews',
  setup: function setup(__props) {
    var isShow = ref(false);
    var navList = ref([{
      title: "首页",
      href: "/"
    }, {
      title: "关于IIFA",
      href: "",
      children: [{
        title: "IIFA全球",
        href: "/international"
      }, {
        title: "IIFA中国",
        href: "/chinese"
      }]
    }, {
      title: "职业认证",
      href: "",
      children: [{
        title: "CIFA认证",
        href: "",
        children: [{
          title: "认证概述",
          href: "/cifa"
        }, {
          title: '考试管理',
          href: '/cifaExam'
        }]
      }, {
        title: 'CWA认证',
        href: '',
        children: [{
          title: "认证概述",
          href: "/cwa"
        }, {
          title: '考试管理',
          href: '/cwaExam'
        }]
      }]
    }, {
      title: "活动与研究",
      href: "",
      children: [{
        title: "活动中心",
        href: "/news"
      }, {
        title: '研究发布',
        href: '/study'
      }]
    }, {
      title: "加入我们",
      href: "/work",
      children: []
    }]);
    var hoverClass = ref(null);
    var handleMouseOver = function handleMouseOver(item) {
      hoverClass.value = item;
      if (item.title == "职业认证") {
        isShow.value = true;
      } else {
        isShow.value = false;
      }
      //
    };
    var handleMouseOut = function handleMouseOut() {
      hoverClass.value = null;
    };
    return function (_ctx, _cache) {
      var _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        srcset: ""
      }, null, -1)), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navList), function (item, index) {
        var _item$children;
        return _openBlock(), _createElementBlock("li", {
          key: index,
          onMouseover: function onMouseover($event) {
            return handleMouseOver(item);
          },
          onMouseleave: handleMouseOut,
          "class": _normalizeClass(index === 3 ? 'aaaa' : '')
        }, [_createVNode(_component_router_link, {
          to: item.href
        }, {
          "default": _withCtx(function () {
            return [_createTextVNode(_toDisplayString(item.title), 1)];
          }),
          _: 2
        }, 1032, ["to"]), _withDirectives(_createElementVNode("ul", {
          "class": _normalizeClass(["animate__animated animate__bounceIn", {
            'flex_column': _unref(isShow)
          }])
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, function (item2, index2) {
          return _openBlock(), _createElementBlock("li", {
            key: index2
          }, [_createVNode(_component_router_link, {
            to: item2.href
          }, {
            "default": _withCtx(function () {
              return [_createTextVNode(_toDisplayString(item2.title), 1)];
            }),
            _: 2
          }, 1032, ["to"]), _unref(isShow) ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.children, function (item3, index3) {
            return _openBlock(), _createElementBlock("div", {
              key: index3
            }, [_createVNode(_component_router_link, {
              to: item3.href
            }, {
              "default": _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item3.title), 1)];
              }),
              _: 2
            }, 1032, ["to"])]);
          }), 128))])) : _createCommentVNode("", true)]);
        }), 128))], 2), [[_vShow, _unref(hoverClass) == item && ((_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.length)]])], 42, _hoisted_3);
      }), 128))])])]);
    };
  }
});